import { useState } from "react";
import { Search, Trash2, ChevronDown, ChevronUp, Calendar, FileText } from "lucide-react";

function notaCor(n) {
  return n >= 8 ? "#10b981" : n >= 6 ? "#f59e0b" : "#ef4444";
}
function notaBg(n) {
  return n >= 8 ? "#d1fae5" : n >= 6 ? "#fef3c7" : "#fee2e2";
}

function CardAvaliacao({ av, onRemover }) {
  const [aberto, setAberto] = useState(false);
  const nota = parseFloat(av.nota);

  return (
    <div style={{
      background: "var(--bg2)", border: "1px solid var(--border)",
      borderRadius: 14, overflow: "hidden", boxShadow: "var(--shadow)",
      transition: "box-shadow .15s"
    }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 16, padding: "16px 20px",
        cursor: "pointer"
      }} onClick={() => setAberto(a => !a)}>
        <div style={{
          width: 48, height: 48, borderRadius: 10, flexShrink: 0,
          background: notaBg(nota), display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center"
        }}>
          <span style={{ fontSize: 16, fontWeight: 800, color: notaCor(nota), lineHeight: 1 }}>{av.nota}</span>
          <span style={{ fontSize: 9, color: notaCor(nota), fontWeight: 500 }}>/10</span>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {av.titulo || "Projeto sem título identificado"}
          </div>
          <div style={{ display: "flex", gap: 12, fontSize: 12, color: "var(--text3)" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Calendar size={11} /> {new Date(av.data).toLocaleDateString("pt-BR")}
            </span>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <FileText size={11} /> {av.edital}
            </span>
          </div>
        </div>
        <div style={{
          padding: "3px 10px", borderRadius: 20,
          background: notaBg(nota), color: notaCor(nota),
          fontSize: 12, fontWeight: 600, flexShrink: 0
        }}>
          {nota >= 8 ? "Destaque" : nota >= 6 ? "Aprovado" : "Revisão"}
        </div>
        <button onClick={e => { e.stopPropagation(); onRemover(av.id); }} style={{
          background: "none", border: "none", color: "var(--text3)", padding: 6,
          borderRadius: 6, display: "flex", transition: "all .15s"
        }}
          onMouseEnter={e => { e.currentTarget.style.background = "#fee2e2"; e.currentTarget.style.color = "#ef4444"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "var(--text3)"; }}
        >
          <Trash2 size={15} />
        </button>
        <div style={{ color: "var(--text3)" }}>
          {aberto ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>

      {aberto && (
        <div style={{ borderTop: "1px solid var(--border)", padding: "20px", background: "var(--bg3)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Projeto enviado</div>
              <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6, maxHeight: 200, overflowY: "auto", whiteSpace: "pre-wrap", background: "var(--bg2)", padding: 12, borderRadius: 8, border: "1px solid var(--border)" }}>
                {av.projeto}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Parecer da IA</div>
              <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6, maxHeight: 200, overflowY: "auto", whiteSpace: "pre-wrap", background: "var(--bg2)", padding: 12, borderRadius: 8, border: "1px solid var(--border)" }}>
                {av.avaliacao}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Historico({ avaliacoes, onRemover, onLimpar }) {
  const [busca, setBusca] = useState("");
  const [filtroNota, setFiltroNota] = useState("todos");

  const filtradas = avaliacoes.filter(a => {
    const buscaOk = !busca || (a.titulo || "").toLowerCase().includes(busca.toLowerCase()) || a.edital.toLowerCase().includes(busca.toLowerCase());
    const notaOk = filtroNota === "todos" ||
      (filtroNota === "alto" && parseFloat(a.nota) >= 8) ||
      (filtroNota === "medio" && parseFloat(a.nota) >= 6 && parseFloat(a.nota) < 8) ||
      (filtroNota === "baixo" && parseFloat(a.nota) < 6);
    return buscaOk && notaOk;
  });

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", background: "var(--bg)" }}>
      <div style={{ background: "var(--bg2)", borderBottom: "1px solid var(--border)", padding: "16px 28px", boxShadow: "var(--shadow)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>Histórico de avaliações</div>
            <div style={{ fontSize: 12, color: "var(--text3)" }}>{avaliacoes.length} avaliações salvas</div>
          </div>
          {avaliacoes.length > 0 && (
            <button onClick={onLimpar} style={{
              fontSize: 12, color: "#ef4444", background: "#fee2e2", border: "none",
              padding: "6px 14px", borderRadius: 8, fontFamily: "inherit", fontWeight: 500
            }}>Limpar tudo</button>
          )}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <div style={{ position: "relative", flex: 1 }}>
            <Search size={14} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text3)" }} />
            <input value={busca} onChange={e => setBusca(e.target.value)}
              placeholder="Buscar por título ou edital..."
              style={{
                width: "100%", padding: "8px 12px 8px 34px", borderRadius: 8,
                border: "1px solid var(--border)", background: "var(--bg3)",
                fontSize: 13, color: "var(--text)", fontFamily: "inherit"
              }} />
          </div>
          {["todos","alto","medio","baixo"].map(f => (
            <button key={f} onClick={() => setFiltroNota(f)} style={{
              padding: "8px 14px", borderRadius: 8, border: "1px solid var(--border)",
              background: filtroNota === f ? "var(--primary)" : "var(--bg3)",
              color: filtroNota === f ? "#fff" : "var(--text2)",
              fontSize: 12, fontFamily: "inherit", fontWeight: 500, transition: "all .15s"
            }}>
              {{ todos: "Todos", alto: "≥ 8", medio: "6–8", baixo: "< 6" }[f]}
            </button>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "24px 28px" }}>
        {filtradas.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "var(--text3)" }}>
            <FileText size={40} style={{ margin: "0 auto 12px", opacity: 0.3, display: "block" }} />
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Nenhuma avaliação encontrada</div>
            <div style={{ fontSize: 13 }}>Faça uma avaliação na aba "Avaliar projeto"</div>
          </div>
        ) : (
          <div style={{ maxWidth: 900, margin: "0 auto", display: "flex", flexDirection: "column", gap: 12 }}>
            {filtradas.map(a => <CardAvaliacao key={a.id} av={a} onRemover={onRemover} />)}
          </div>
        )}
      </div>
    </div>
  );
}
